var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArmenia = function SvgArmenia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#armenia_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 5.313h20v9.375H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M0 13.438h20V20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 0h20v6.563H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "armenia_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 2
  })))));
};
export { SvgArmenia as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI2MDA0XzE0NTI3KSI+CjxwYXRoIGQ9Ik0wIDUuMzEyNUgyMFYxNC42ODc1SDBWNS4zMTI1WiIgZmlsbD0iIzAwNTJCNCIvPgo8cGF0aCBkPSJNMCAxMy40Mzc1SDIwVjIwSDBWMTMuNDM3NVoiIGZpbGw9IiNGRjk4MTEiLz4KPHBhdGggZD0iTTAgMEgyMFY2LjU2MjVIMFYwWiIgZmlsbD0iI0Q4MDAyNyIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI2MDA0XzE0NTI3Ij4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";